export class closeEvidanceInputModel {
    FileName:string;
    FileUrl:string;
    FileType:string;
    FileExtension:string;
    Id:number;
    JurisdictionId:number
    constructor() {
        this.FileExtension='';
        this.FileName='';
        this.FileType='';
        this.FileUrl='';
        this.Id=0;
        this.JurisdictionId=0;
    }
}
export class bulkcloseEvidanceInputModel {
    FileName:string;
    FileUrl:string;
    FileType:string;
    FileExtension:string;
    Id:string;
    JurisdictionId:number
    constructor() {
        this.FileExtension='';
        this.FileName='';
        this.FileType='';
        this.FileUrl='';
        this.Id='';
        this.JurisdictionId=0;
    }
}